import React, { useState } from "react";
import classes from "./FilteringSection.module.css";
import { Text } from "components/common";
import Devider2 from "components/common/Devider2/Devider";
const sentiments = ["Bullish", "Neutral", "Bearish"];

const suggestedActions = [
  "Strong Buy",
  "Buy",
  "Neutral",
  "Sell",
  "Strong Sell",
];
const trendPattern = ["Continue", "Reversal"];
const FilteringSection = () => {
  const [activeSentiment, setActiveSentiment] = useState("Bullish");
  const [activeSuggestedAction, setActiveSuggestedAction] =
    useState("Strong Buy");
  const [activeTrendPattern, setActiveTrendPattern] = useState("Continue");
  const handleSentiment = (button) => {
    setActiveSentiment(button);
  };
  const handleSuggestedAction = (button) => {
    setActiveSuggestedAction(button);
  };
  const handleTrendPattern = (button) => {
    setActiveTrendPattern(button);
  };

  return (
    <div className={classes.container}>
      <div className={classes.filterBy}>
        <Text primitive200 sm>
          Sentiment
        </Text>
        <div className={classes.sentiments}>
          {sentiments?.map((button, i) => (
            <button
              key={i}
              className={`${classes.button} ${
                activeSentiment === button ? classes.active : ""
              }`}
              onClick={() => handleSentiment(button)}
            >
              {button}
            </button>
          ))}
        </div>
      </div>
      <div className={classes.filterBy}>
        <Text primitive200 sm>
          Suggested Action
        </Text>
        <div className={classes.suggestedActions}>
          {suggestedActions?.map((button, i) => (
            <button
              key={i}
              className={`${classes.button} ${
                activeSuggestedAction === button ? classes.active : ""
              }`}
              onClick={() => handleSuggestedAction(button)}
            >
              {button}
            </button>
          ))}
        </div>
      </div>
      <div className={classes.filterBy}>
        <Text primitive200 sm>
          Trend Pattern
        </Text>
        <div className={classes.trendPattern}>
          {trendPattern?.map((button, i) => (
            <button
              key={i}
              className={`${classes.button} ${
                activeTrendPattern === button ? classes.active : ""
              }`}
              onClick={() => handleTrendPattern(button)}
            >
              {button}
            </button>
          ))}
        </div>
      </div>
      <Devider2 />
      <Text textCenter primitive300 className={classes.financialAdvice}>
        Not financial advice
      </Text>
    </div>
  );
};

export default FilteringSection;
